export default __webpack_public_path__ + "static/media/upload-image-primary.90356298.png";